import { useEffect, useState } from 'react';
import clsx from 'clsx';

/**
 * Initials-on-circle avatar. Extracted from what used to be duplicated inline
 * in AppLayout and FileChatPanel — now a third caller (the share people-list)
 * made a shared component worth it. Deliberately unstyled by default (no
 * background/text color baked in) so each caller's existing look is passed in
 * via `className` rather than risking a Tailwind utility-order override.
 *
 * Pass `src` to show a picture instead of initials; it falls back to initials
 * automatically when the image is missing or fails to load.
 */
export default function Avatar({ name, src, className }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);

  const initials = (name ?? '?')
    .split(' ')
    .map((p) => p[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
  const showImage = src && !failed;
  return (
    <span
      className={clsx(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full',
        className,
      )}
    >
      {showImage ? (
        <img
          src={src}
          alt=""
          className="h-full w-full object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        initials
      )}
    </span>
  );
}
